module.exports = __webpack_public_path__ + "img/expand.7007b11.webp";